<template>
    <div rel="schema:shippingDetails">
        <div typeof="schema:OfferShippingDetails">
            <div rel="schema:shippingRate">
                <div typeof="schema:MonetaryAmount">
                    <div property="schema:minValue" content="60"></div>
                    <div property="schema:currency" content="UAH"></div>
                </div>
            </div>
            <div rel="schema:shippingDestination">
                <div typeof="schema:DefinedRegion">
                    <div property="schema:addressCountry"
                         content="UA"></div>
                </div>
            </div>
            <div rel="schema:deliveryTime">
                <div typeof="schema:ShippingDeliveryTime">
                    <div rel="schema:handlingTime">
                        <div typeof="schema:QuantitativeValue">
                            <div property="schema:minValue"
                                 content="0"></div>
                            <div property="schema:maxValue"
                                 content="1"></div>
                            <div property="schema:unitCode"
                                 content="DAY"></div>
                        </div>
                    </div>
                    <div rel="schema:transitTime">
                        <div typeof="schema:QuantitativeValue">
                            <div property="schema:minValue"
                                 content="1"></div>
                            <div property="schema:maxValue"
                                 content="3"></div>
                            <div property="schema:unitCode"
                                 content="DAY"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div property="schema:itemCondition" content="https://schema.org/NewCondition"></div>
    <div rel="schema:url" :resource="route('products.show', [product])"></div>
    <meta property="schema:priceCurrency" :content="product.price?.currency || 'UAH'" />
    <meta property="schema:priceValidUntil" :content="priceValidUntil"/>
    <div property="schema:availability"
         :content="product.is_active ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock'"></div>
</template>

<script>
import {date} from "@/Helpers/dayjs.js";

export default {
    props: {
        product: Object
    },
    data() {
        return {
            priceValidUntil: date().add(1, 'year').toISOString(),
        }
    }
}
</script>
